// import Script from "next/script";

import Head from "next/head";
import { useEffect, useState } from "react";

const MGIDScript = ({delay=false}) => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setScrolled(true);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    (scrolled&&delay)?<Head>
      <script
        id="mgid-ads"
        src="https://jsc.mgid.com/site/941524.js"
        // strategy="lazyOnload"
        async
      ></script>
    </Head>:
    !delay?<Head>
      <script
        id="mgid-ads"
        src="https://jsc.mgid.com/site/941524.js"
        // strategy="lazyOnload"
        async
      ></script>
    </Head>:<></>
  );
};

export default MGIDScript;
